import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import AuthService from "../../services/auth.service";

export const fetchWallet= createAsyncThunk('fetchWallet', async () => {
    const response = await AuthService.wallet();
    return response?.data;   
});

const wallet= {
    user_combined_wallet: 0.00,
    user_promotional_wallet: 0,
    user_winning_wallet: 0
}
export const walletSlice = createSlice({
    name: 'wallet',
    initialState: {
        wallet: wallet,        
    },
    reducers: {},
    extraReducers: (builder) => {        
        builder.addCase(fetchWallet.fulfilled, (state, action) => {
            state.wallet = action.payload;
        });        
    }
})

export default walletSlice.reducer